import { createSlice } from "@reduxjs/toolkit";
import { AuthSliceInterface } from "interfaces/authInterface";

export const authSlice = createSlice({
  name: "auth",
  initialState: {
    status: "not-authenticated",
    user: {},
    errorMessage: null,
    showModalAuthentication: false,
    showModalChangePassword: false,
    urlPhoto: "",
    imagenHora: "",
    seccionSelect: 0,
    lstFAQ: [],
    isNorma: false,
  } as AuthSliceInterface,
  reducers: {
    onChecking: (state) => {
      state.status = "checking";
      state.user = {};
      state.errorMessage = null;
    },
    onLogin: (state, { payload }) => {
      state.status = "authenticated";
      state.user = payload;
      state.errorMessage = null;
    },
    onLogout: (state, { payload }) => {
      state.status = "not-authenticated";
      state.user = {};
      state.errorMessage = payload;
    },
    clearErrorMessage: (state) => {
      state.errorMessage = null;
    },
    setShowModalAuthentication: (state, { payload }) => {
      state.showModalAuthentication = payload;
    },
    onChangeOpenModalPassword: (state, { payload }) => {
      state.showModalChangePassword = payload;
    },
    onAddImageProfile: (state, { payload }) => {
      state.urlPhoto = payload;
    },
    onAddImagenHora: (state, { payload }) => {
      state.imagenHora = payload;
    },
    onSetSeccionSelect: (state, { payload }) => {
      state.seccionSelect = payload;
    },
    onGetLstFAQ: (state, { payload }) => {
      state.lstFAQ = payload;
    },
    onSetNormas: (state, { payload }) => {
      state.isNorma = payload;
    },
  },
});

//actions creators are generated for each case reducer function
export const {
  onChecking,
  onLogin,
  onLogout,
  clearErrorMessage,
  setShowModalAuthentication,
  onChangeOpenModalPassword,
  onAddImageProfile,
  onAddImagenHora,
  onSetNormas,
  onSetSeccionSelect,
  onGetLstFAQ,
} = authSlice.actions;
